import React, { lazy, Component } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import Navbar from '../components/Navbar';
const TryFluidForm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const prompt = searchParams.get('prompt') || '';
  const iframeSrc = prompt ? `https://app.fluid-form.ai/try?prompt=${encodeURIComponent(prompt)}` : 'https://app.fluid-form.ai/try';
  return <div className="w-full min-h-screen font-sans bg-gray-50 flex flex-col" data-id="element-650">
      <Navbar data-id="element-651" />
      <div className="px-4 py-3 border-b border-gray-200 bg-white" data-id="element-652">
        <div className="container mx-auto flex items-center gap-3" data-id="element-653">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-654">
            <ArrowLeftIcon size={16} data-id="element-655" />
            Back to home
          </button>
          {prompt && <span className="text-gray-400 text-sm hidden sm:inline" data-id="element-656">
              — Creating:{' '}
              <span className="text-gray-600 italic" data-id="element-657">"{prompt}"</span>
            </span>}
        </div>
      </div>
      <div className="flex-1 w-full" data-id="element-658">
        <iframe src={iframeSrc} className="w-full h-full border-0" style={{
        minHeight: 'calc(100vh - 120px)'
      }} title="FluidForm Builder" allow="microphone; camera" loading="lazy" data-id="element-659" />
      </div>
    </div>;
};
export default TryFluidForm;